/* eslint-disable @typescript-eslint/no-explicit-any */
import React, {useCallback, useEffect, useRef, useState} from 'react';
import {Dimensions, Platform, ScrollView, View} from 'react-native';
import {connect} from 'react-redux';
import {BREAKPOINT} from '../../../data/constants/screen';
import {ChatProps} from '../../../data/types/interface/chat';
import mapDispatchToProps from '../../../services/redux/mapDispatchToProps';
import mapStateToProps from '../../../services/redux/mapStateToProps';
import {buttonsStyles} from '../../components/Button/boutonStyle';
import Button from '../../components/Button/PrimaryButton';
import {ChatComponent} from '../../components/Chat/ChatComponent';
import {ChatIcon} from '../../components/Chat/ChatIcon';
import {HeaderScreen} from '../../components/Header/HeaderScreen';
import {formsStyles} from '../../components/Inputs/formStyles';
import {Loader} from '../../components/Loader';

const FAQScreen = (props: any) => {
  const [checkResponse, setCheckResponse] = useState(false);
  const [listChat, setListChat] = useState([] as ChatProps[]);
  const [listNotClick, setListNotClick] = useState([] as number[]);
  const [isRechat, setIsRechat] = useState(false);
  const [isLoading, setLoading] = useState(false);
  const {
    theme: {},
    getRacinesTheme,
    getEnfantsTheme,
  } = props;

  const scrollRef = useRef<any | null>(null);

  useEffect(() => {
    getTheme();
  }, []);

  const timeNow = useCallback(() => {
    const time = new Date();
    return time.getMinutes() < 10
      ? time.getHours() + ':0' + time.getMinutes()
      : time.getHours() + ':' + time.getMinutes();
  }, []);

  const getTheme = () => {
    setListChat([]);
    setListNotClick([]);
    setLoading(true);
    getRacinesTheme({}, (res: any) => {
      if (res && res.data) {
        setListChat(oldChats => [
          ...oldChats,
          {
            dataTheme: res.data,
            time: timeNow(),
            description: 'Bonjour ... veuillez faire votre choix',
            reponse: 'Bonjour',
          },
        ]);
      }
      setLoading(false);
    });
  };

  const getResponse = (item: any) => {
    const {id, titre, reponse} = item;
    setCheckResponse(true);
    if (reponse && reponse.length > 1) {
      setIsRechat(true);
      setListChat(oldChats => [
        ...oldChats,
        {dataTheme: [], time: timeNow(), description: reponse, reponse: titre},
      ]);
    } else {
      setIsRechat(false);
      getEnfantsTheme(
        {},
        (res: any) => {
          if (res && res.data) {
            if (res.data.length === 0) {
              setIsRechat(true);
              setListChat(oldChats => [
                ...oldChats,
                {
                  dataTheme: [],
                  time: timeNow(),
                  description: 'Aucune information',
                  reponse: titre,
                },
              ]);
            } else {
              setListChat(oldChats => [
                ...oldChats,
                {
                  dataTheme: res.data,
                  time: timeNow(),
                  description: 'Veuillez faire votre choix',
                  reponse: titre,
                },
              ]);
            }
          }
        },
        `${id}`,
      );
    }
  };
  const index = (indexChat: number) => {
    return listNotClick.indexOf(indexChat);
  };
  const getChatId = (item: any) => {
    for (let i = 0; i < listChat.length; i++) {
      if (listChat[i].dataTheme.some(data => data.id === item.id)) {
        return i;
      }
    }
    return -1;
  };
  const handleClick = ({item}: {item: any}) => {
    const indexChat = getChatId(item);
    if (index(indexChat) === -1) {
      !isRechat && getResponse(item);
      listNotClick.push(indexChat);
    }
  };
  const newChat = () => {
    setIsRechat(false);
    getTheme();
  };
  return (
    <View>
      <HeaderScreen title="FAQ" type="home" noBreadcrumb={false} isNoChatBot />
      <ChatIcon />

      <View
        style={[
          formsStyles.webformContainChat,
          {
            paddingHorizontal:
              Platform.OS === 'web' &&
              Dimensions.get('window').width > BREAKPOINT.sm
                ? 80
                : 20,
          },
        ]}>
        <View style={{...formsStyles.formContainChat}}>
          <ScrollView
            ref={scrollRef}
            showsVerticalScrollIndicator={Platform.OS === 'web' && false}
            onContentSizeChange={() =>
              scrollRef?.current.scrollToEnd({animated: true})
            }
            style={{marginBottom: 80}}>
            {isLoading && <Loader />}
            {listChat.map((e: any, index: any) => {
              return (
                <ChatComponent
                  time={e.time}
                  key={index}
                  data={e.dataTheme}
                  description={e.description}
                  response={e.reponse}
                  checkResponse={checkResponse}
                  handleClick={handleClick}
                />
              );
            })}
            {isRechat && (
              <Button
                onPress={() => newChat()}
                title="Démarrer une nouvelle conversation"
                type="valider"
                styleBtnTxt={buttonsStyles.btnValider}
                styleBtnOuter={buttonsStyles.btnValiderOuter}
              />
            )}
          </ScrollView>
        </View>
      </View>
    </View>
  );
};

export const FAQ: any = connect(mapStateToProps, mapDispatchToProps)(FAQScreen);
